import { toast } from 'App';
import { isAxiosError } from 'axios';
import { $api } from './interceptor';
import { TNetworkList } from 'views/types/tokens';

const tokenApi = () => {
  const getTokenInfo = async (): Promise<TNetworkList[]> => {
    try {
      const { data } = await $api.get<TNetworkList[]>('/api/mexc/token-status');
      return data;
    } catch (error) {
      errorHandler(error);
    }
  };

  const errorHandler = (error: unknown) => {
    console.error(error);

    let description = 'Something went wrong. Please try again later.';

    if (isAxiosError(error)) {
      const responseMessage = error.response?.data?.message;

      if (typeof responseMessage === 'string') {
        description = responseMessage;
      } else if (Array.isArray(responseMessage)) {
        description = responseMessage.join(', ');
      }
    }

    toast({
      title: 'Error',
      description,
      status: 'error',
      duration: 3000,
      isClosable: true,
      position: 'top-right',
    });
  };

  return { getTokenInfo };
};

export const tokenService = tokenApi();
